import { render, staticRenderFns } from "./SearchDisplay.vue?vue&type=template&id=a4275332&"
import script from "./SearchDisplay.vue?vue&type=script&lang=ts&"
export * from "./SearchDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports